// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__22WZJ","filesListContainer":"PosDisputesFiles_filesListContainer__3U143","filesButton":"PosDisputesFiles_filesButton__2bcd3"};